import React, { useEffect } from "react";
const NEWS_URL = "https://wolfdognews.com/";
export default function ExternalNews() {
 useEffect(() => { window.location.replace(NEWS_URL); }, []);
 return <section className="container-x py-24" aria-live="polite"><h1 className="font-display text-4xl">Wolfdog News</h1><p className="mt-4 text-muted-foreground">Opening WolfdogNews.com.</p><a className="btn-primary mt-6" href={NEWS_URL}>Continue to Wolfdog News</a></section>;
}
